import { Text } from "@smooth/design-system-components"
import type { GenerationMetadata } from "../types"

/**
 * AI の判断記録（自己申告）。判断記録（decision）があれば、まとめ・AI が通った道筋（strategy.path のノードと yes/no）・
 * 各歩の問い → 答えと根拠・理由を読める形で出す。判断記録の無い版の生成は、観測の道筋（ノードと結果）を並べるだけにする
 */
export function DecisionRecord({ metadata }: { metadata: GenerationMetadata | null | undefined }) {
  const decision = metadata?.decision
  const steps = decision?.steps ?? []
  const legacy = metadata?.strategy?.path ?? []

  if (decision && (steps.length || decision.summary)) {
    return (
      <div className="flex flex-col gap-2">
        {decision.summary && <Text>まとめ：{decision.summary}</Text>}
        {legacy.length > 0 && (
          <Text size="sm">
            道筋：
            {legacy.map((step) => `${step.nodeId ?? "—"} ${step.result ?? "—"}`).join(" → ")}
          </Text>
        )}
        {steps.length > 0 && (
          <ol className="list-decimal pl-6 text-body text-text-default">
            {steps.map((step, index) => (
              <li key={index} className="py-1">
                <span className="font-bold">{step.node || "—"}</span> {step.question}{" "}
                <span className="whitespace-nowrap">→ {step.answer || "—"}</span>
                {step.evidence && (
                  <span className="block text-caption text-text-muted">根拠：{step.evidence}</span>
                )}
                {step.reason && (
                  <span className="block text-caption text-text-muted">理由：{step.reason}</span>
                )}
              </li>
            ))}
          </ol>
        )}
      </div>
    )
  }
  if (legacy.length) {
    return (
      <ol className="list-decimal pl-6 text-body text-text-default">
        {legacy.map((step, index) => (
          <li key={index}>
            <span className="font-bold">{step.nodeId ?? "—"}</span> → {step.result ?? "—"}
          </li>
        ))}
      </ol>
    )
  }
  return <Text size="sm">判断の記録はありません。</Text>
}
